module.exports = __webpack_public_path__ + "static/img/culture-payback.425d09df.png";